<template>
  <b-modal
    id="modalCreateEditCategoria"
    size="x2"
    :title="textModal"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal', false)"
  >
    <form @submit.prevent="save">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label>Descrição: <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.categoria.descricao.$error }"
            placeholder="Descrição da categoria de modelos de peça"
            v-model="$v.categoria.descricao.$model"
          />
          <span
            v-if="!$v.categoria.descricao.required"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
          <span
            v-if="!$v.categoria.descricao.minLength"
            class="invalid-feedback"
          >
            A descrição deve possuir pelo menos 3 caracteres
          </span>
        </div>
      </div>
      <div v-if="categoriaId" class="form-row">
        <div class="form-group col-sm-6">
          <p>Status: <span class="text-danger">*</span></p>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusInativo"
              value="0"
              v-model="categoria.status"
            />
            <label class="form-check-label" for="statusInativo">
              Inativo
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusAtivo"
              value="1"
              v-model="categoria.status"
            />
            <label class="form-check-label" for="statusAtivo"> Ativo </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn btn-secondary"
          title="Cancelar"
          @click="$emit('closeModal', false)"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :title="textModal"
          :disabled="$v.$invalid || disableButton"
        >
          <i
            v-if="disableButton"
            class="spinner-grow spinner-grow-custom text-wither"
          />
          <span v-else>{{ textModal }}</span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateEditCategoriaModal',
  props: {
    categoriaId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      categoria: {
        descricao: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.categoriaId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getCategoria() {
      try {
        this.categoria = await this.$store.dispatch(
          'getCategoria',
          this.categoriaId,
        )
        this.$bvModal.show('modalCreateEditCategoria')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.categoriaId) {
            response = await this.$store.dispatch(
              'updateCategoria',
              this.categoria,
            )
          } else {
            response = await this.$store.dispatch(
              'saveCategoria',
              this.categoria,
            )
          }
          this.disableButton = false
          this.$root.$bvToast.toast(response.message, {
            title: 'Sucesso!',
            variant: 'success',
            solid: true,
          })
          this.$emit('closeModal', true)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$bvToast.toast(error.message, {
              title: 'Atenção!',
              variant: 'warning',
              solid: true,
            })
          } else {
            this.$root.$bvToast.toast(
              'Não foi possível se conectar ao servidor.',
              {
                title: 'Erro!',
                variant: 'danger',
                solid: true,
              },
            )
          }
        }
      }
    },
  },

  validations: {
    categoria: {
      descricao: {
        required,
        minLength: minLength(3),
      },
    },
  },

  mounted() {
    if (this.categoriaId) {
      this.getCategoria()
    } else {
      this.$bvModal.show('modalCreateEditCategoria')
    }
  },
}
</script>
